import { useState, useEffect } from "react";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";

import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { WhyDubai } from "./components/WhyDubai";
import { Experience } from "./components/Experience";
import { Projects } from "./components/Projects";
import { Founder } from "./components/Founder";
import { Developers } from "./components/Developers";
import { ContactForm } from "./components/ContactForm";
import { Footer } from "./components/Footer";
import { LeadModal } from "./components/LeadModal";
import { CookieBanner } from "./components/CookieBanner";
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";
import TilalBinghatti from "./pages/TilalBinghatti";
import AboutUs from "./pages/AboutUs";
import ProjectsPage from "./pages/ProjectsPage";
import ProjectDetail from "./pages/ProjectDetail";
import DevelopersPage from "./pages/DevelopersPage";
import OurServices from "./pages/OurServices";
import InvestmentGuide from "./pages/InvestmentGuide";
import FAQPage from "./pages/FAQPage";
import ClientReviews from "./pages/ClientReviews";
import ContactUs from "./pages/ContactUs";
import { PrivacyPolicy, Terms, InvestmentDisclaimer } from "./pages/Legal";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
};

const Landing = () => {
  const [prefillProject, setPrefillProject] = useState(null);
  const [consultOpen, setConsultOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("udp_consult_shown") === "1") return;
    const t = setTimeout(() => {
      setConsultOpen(true);
      sessionStorage.setItem("udp_consult_shown", "1");
    }, 3500);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="App" data-testid="landing-page">
      <Navbar onOpenConsult={() => setConsultOpen(true)} />
      <Hero onOpenConsult={() => setConsultOpen(true)} />
      <WhyDubai />
      <Experience />
      <Projects />
      <Founder />
      <Developers />
      <ContactForm
        prefillProject={prefillProject}
        onClearPrefill={() => setPrefillProject(null)}
      />
      <Footer />
      <CookieBanner />
      <LeadModal
        open={consultOpen}
        onClose={() => setConsultOpen(false)}
        projectName="Universal Dream Properties"
        accentColor="#C5A059"
        unitLabel="Property type of interest"
        unitOptions={[
          "Off-plan apartment",
          "Off-plan villa / townhouse",
          "Ready apartment",
          "Ready villa / townhouse",
          "Commercial / retail",
          "Not sure yet — please advise",
        ]}
        headline={
          <>
            Book your private
            <br />
            <em className="italic" style={{ color: "#C5A059" }}>consultation</em>
          </>
        }
        subheadline="Share a few details and a senior investment advisor will contact you within one business day with a personalised shortlist and payment plan."
      />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects/:id" element={<ProjectDetail />} />
        <Route path="/developers" element={<DevelopersPage />} />
        <Route path="/services" element={<OurServices />} />
        <Route path="/investment-guide" element={<InvestmentGuide />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/reviews" element={<ClientReviews />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/disclaimer" element={<InvestmentDisclaimer />} />
        <Route path="/tilal-binghatti" element={<TilalBinghatti />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
      <Toaster position="top-center" richColors theme="dark" />
    </BrowserRouter>
  );
}

export default App;
